/**
 * @param root0
 * @param root0.store
 * @param root0.redirect
 */
export default async function ({ store, redirect }) {
  if (!store.getters["user/IS_LOGGED_IN"] || !store.getters["user/IS_AGENCY"])
    return redirect("/")
  if (store.getters["user/band_set/LIVE_BANDS"].length <= 1)
    return redirect("/band/profile/select/")
}
